/**
 * Club Files assigns temporary IDs to uploads for entities
 * that have not yet been created (temp_1, temp_2, etc.).
 *
 * When an entity is created and assigned an ID,
 * it must be reported so that the temporary IDs can be updated accordingly.
 */
export function updateTemporaryId(entityId) {
    window.dispatchEvent(new CustomEvent('app-content-admin:upload:update-temporary-id', {
        detail: { id: entityId }
    }));
}
